import { render } from "./PlaceDetails.vue?vue&type=template&id=0457abd4"
import script from "./PlaceDetails.vue?vue&type=script&lang=js"
export * from "./PlaceDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__